// ____________상단 탭 메뉴 ___________
// fileDetail.jsx ...
export default function TabMenu({
  currentTab,
  setCurrentTab,
  labels = [],
  disabledValues = [],
}) {
  const normalizeItem = (item) => {
    if (typeof item === "string") {
      return {
        value: item,
        label: item,
        disabled: item === "보고서 생성 중",
      };
    }

    return {
      value: item?.value,
      label: item?.label ?? item?.value,
      disabled: Boolean(item?.disabled),
    };
  };

  const isDisabled = (item) =>
    item.disabled || disabledValues.includes(item.value);

  const handleClick = (item) => {
    if (!item?.value || isDisabled(item)) return;
    setCurrentTab(item.value);
  };

  return (
    <ul className="tabMenu">
      {labels.map((item, idx) => {
        const normalized = normalizeItem(item);
        const disabled = isDisabled(normalized);

        return (
          <li
            onClick={() => handleClick(normalized)}
            role="button"
            tabIndex={disabled ? -1 : 0}
            aria-disabled={disabled || undefined}
            aria-pressed={currentTab === normalized.value}
            onKeyDown={event => { if (event.key === "Enter" || event.key === " ") { event.preventDefault(); handleClick(normalized); } }}
            key={`${normalized.value ?? "tab"}${idx}`}
            className={
              currentTab === normalized.value
                ? "active"
                : disabled
                  ? "loading-text"
                  : ""
            }
          >
            {normalized.label}
          </li>
        );
      })}
    </ul>
  );
}
